<template>
  <div v-if="field.textType == 'currency'">{{ numeral(modalRef.text).format('0,0') }}</div>
  <div v-else-if="field.textType == 'string'">{{ modalRef.text }}</div>
  <div v-else-if="field.textType == 'number'">{{ modalRef.text }}</div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent, onMounted, reactive, watch } from 'vue';
import getFormConfig from 'liyu-pc-base/components/FormRender/RemoteText/index';
import type { ReponseData } from 'liyu-pc-base/utils/hooks/useFetchData';
import numeral from 'numeral';

type Field = {
  modalType: string;
  textType: 'string' | 'number' | 'currency';
};

export default defineComponent({
  name: 'RemoteText',
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
    value: {
      type: [Array, Number, String],
      required: false,
      default: () => null,
    },
    label: {
      type: [Array, String],
      required: false,
      default: () => [],
    },
    formModel: {
      type: Object,
      required: true,
    },
    init_model: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const modalRef = reactive({
      text: null,
    });
    const { searchConfig, getData } = getFormConfig(props.field.modalType);
    const search_modelRef = reactive({
      ...searchConfig.model,
      ...props.init_model,
    });
    const check_params_need_request = () => {
      let is_ok = true;
      if (searchConfig.watch) {
        for (const k of searchConfig.watch) {
          if (props.formModel) {
            if (
              (props.formModel[k] === null || props.formModel[k] === undefined) &&
              props.init_model &&
              (props.init_model[k] === null || props.init_model[k] === undefined)
            ) {
              is_ok = false;
            }
          }
        }
      }
      return is_ok;
    };
    const old_obj: { [key: string]: any } = {};
    onMounted(() => {
      let is_use = false;
      if (searchConfig.watch) {
        for (const k of searchConfig.watch) {
          if (props.formModel) {
            old_obj[k] = props.formModel[k];
          }
        }
      }
      if (searchConfig.watch && props.formModel) {
        for (const k of searchConfig.watch) {
          search_modelRef[k] = props.formModel[k];
          watch(
            () => props.formModel[k],
            () => {
              let change = false;
              if (searchConfig.watch && props.formModel) {
                for (const k of searchConfig.watch) {
                  if (old_obj[k] != props.formModel[k] && props.formModel[k]) {
                    change = true;
                    search_modelRef[k] = props.formModel[k];
                  }
                }
              }
              if (change && check_params_need_request()) {
                getData({ ...search_modelRef }).then(function (res: ReponseData<any>) {
                  modalRef.text = res;
                  emit('update:value', modalRef.text);
                });
              }
            },
            { immediate: true },
          );
        }
      }
      if (searchConfig.attr_use && searchConfig.attr_use.length > 0) {
        for (const k of searchConfig.attr_use) {
          if (props.formModel && props.formModel[k]) {
            is_use = true;
          } else {
            is_use = false;
            break;
          }
        }
      } else {
        if (check_params_need_request()) {
          getData({ ...search_modelRef }).then(function (res: ReponseData<any>) {
            modalRef.text = res;
            emit('update:value', modalRef.text);
          });
        }
      }
      if (is_use && check_params_need_request()) {
        getData({ ...search_modelRef }).then(function (res: ReponseData<any>) {
          modalRef.text = res;
          emit('update:value', modalRef.text);
        });
      }
    });

    return {
      props,
      modalRef,
      search_modelRef,
      searchConfig,
      numeral,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
  components: {},
});
</script>
